import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faClock,
    faTint,
    faExpand,
    faPlus,
    faMinus,
    faUser,
    faUsers,
    faCheck,
    faInfo,
    faTimes,
    faMagic,
    faImage,
    faSave,
    faArrowUp,
    faArrowDown,
    faArrowRight,
    faEdit,
    faSearch,
    faSyncAlt,
    faPen,
    faLongArrowAltDown,
    faLongArrowAltUp,
    faFilter,
    faTable,
    faSort,
    faAngleDoubleRight,
    faAngleDoubleLeft,
    faInfoCircle,
    faSignOutAlt,
    faBook,
    faBars,
    faTrash,
    faArrowLeft,
    faTachometerAlt,
    faFileAlt,
    faCalendarAlt,
    faDownload,
    faShare,
    faChevronRight,
    faList,
    faEye,
    faPlay,
    faPause,
    faPaperPlane,
    faExternalLinkAlt,
    faShareAlt,
    faSlidersH,
    faThumbsUp,
    faCog,
    faEnvelope,
    faMapMarkerAlt,
    faBrain,
    faBuilding,
    faFilePdf,
    faFileUpload,
    faSpellCheck,
    faUserCheck,
    faAt,
    faChevronLeft,
    faUserSecret,
    faChevronUp,
    faChevronDown,
    faEnvelopeCircleCheck,
    faUpRightFromSquare,
    faPeopleGroup,
    faPersonChalkboard,
    faPersonCircleCheck,
    faPersonBurst,
    faPersonHiking,
    faPeopleCarryBox,
    faUserCircle,
    faLock,
    faUnlock,
    faKey,
    faRotate,
    faTriangleExclamation,

    // WYSIWYG Editor Icons
    faBold,
    faItalic,
    faUnderline,
    faListUl,
    faListOl,
    faUndo,
    faRedo,
    faHeading,
    faParagraph,
    faClipboardCheck,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faClock,
    faTint,
    faExpand,
    faPlus,
    faMinus,
    faUser,
    faUsers,
    faCheck,
    faInfo,
    faTimes,
    faMagic,
    faImage,
    faSave,
    faArrowUp,
    faArrowDown,
    faArrowRight,
    faEdit,
    faSearch,
    faSyncAlt,
    faPen,
    faLongArrowAltDown,
    faLongArrowAltUp,
    faFilter,
    faTable,
    faSort,
    faAngleDoubleRight,
    faAngleDoubleLeft,
    faInfoCircle,
    faSignOutAlt,
    faBook,
    faBars,
    faTrash,
    faArrowLeft,
    faTachometerAlt,
    faFileAlt,
    faCalendarAlt,
    faDownload,
    faShare,
    faChevronRight,
    faList,
    faEye,
    faPlay,
    faPause,
    faPaperPlane,
    faExternalLinkAlt,
    faShareAlt,
    faSlidersH,
    faThumbsUp,
    faCog,
    faEnvelope,
    faMapMarkerAlt,
    faBrain,
    faBuilding,
    faFilePdf,
    faFileUpload,
    faSpellCheck,
    faUserCheck,
    faAt,
    faChevronLeft,
    faUserSecret,
    faChevronUp,
    faChevronDown,
    faEnvelopeCircleCheck,
    faUpRightFromSquare,
    faPeopleGroup,
    faPersonChalkboard,
    faPersonCircleCheck,
    faPersonBurst,
    faPersonHiking,
    faPeopleCarryBox,
    faUserCircle,
    faLock,
    faUnlock,
    faKey,
    faRotate,
    faTriangleExclamation,

    // WYSIWYG Editor Icons
    faBold,
    faItalic,
    faUnderline,
    faListUl,
    faListOl,
    faUndo,
    faRedo,
    faHeading,
    faParagraph,
    faClipboardCheck
)
